import React, { useEffect, useState, Fragment } from "react";
import { Form, Input, Select, Button, Modal, message, Spin, Alert, Row, Col, InputNumber, Divider, Tabs } from "antd";
import styles from "../management.module.scss";
import { useTranslation } from "react-i18next";
import { CharacterVerify, CharacterVerifyTelegramToken } from "../../../Utility/RegExp";
import { custInfRecordProps } from "../index";
import { useCustomerNotification, useTestNotification, useUpdateNotification } from "../queries";
import { useSetting } from "Components/Header/queries";
import { useAppSelector } from "store/hook";

const { Option } = Select;
const { TabPane } = Tabs;

interface notificationProps {
  setRecord: (arg: custInfRecordProps) => void;
  record: custInfRecordProps;
  NotifiModalvisible: boolean;
  setNotifiModalvisible: (arg: boolean) => void;
}

const NotifiModalC = React.memo(
  ({ setRecord, record, NotifiModalvisible, setNotifiModalvisible }: notificationProps) => {
    const [form] = Form.useForm();

    const [MailActive, setMailActive] = useState(false);
    // const [LineActive, setLineActive] = useState(false);
    const [telegramActive, setTelegramActive] = useState(false);
    const [discordActive, setDiscordActive] = useState(false);
    const [slackActive, setSlackActive] = useState(false);
    const [ntfyActive, setNtfyActive] = useState(false);
    // teamPlus 依照使用者需求而開放
    const [teamPlusActive, setTeamPlusActive] = useState(false);
    const [activeTab, setActiveTab] = useState("1");

    const [MQTTActive, setMQTTActive] = useState("disable");
    const [MQTTSecure, setMQTTSecure] = useState("none");
    const [ChatworkActive, setChatworkActive] = useState(false);
    const { isLogin, level, user } = useAppSelector((state) => state.global);
    const { data: useSettingData } = useSetting(user, level, isLogin);
    const { teamPlusNotify, chatWorkNotify } = useAppSelector((state) => state.management);

    const { t } = useTranslation();
    const { data: customerNotification, isFetching: customerNotificationFetching } = useCustomerNotification(
      record?.cid,
      NotifiModalvisible
    );
    const { mutateAsync: testNotificationMutation, isLoading: testNotificationLoading } = useTestNotification();
    const { mutateAsync: updateNotificationMutation, isLoading: updateNotificationLoading } = useUpdateNotification(
      record.cid
    );
    const notiFetching = testNotificationLoading || updateNotificationLoading || customerNotificationFetching;

    useEffect(() => {
      if (!customerNotification || !NotifiModalvisible) {
        return;
      }
      setActiveTab("1");
      const mail_active = customerNotification.mail?.active !== "" ? customerNotification.mail?.active : false; //CGI response '', not boolean
      // const line_active = customerNotification.line?.active !== "" ? customerNotification.line?.active : false;
      const telegram_active =
        customerNotification.telegram?.active !== "" ? customerNotification.telegram?.active ?? false : false;
      const discord_active =
        customerNotification.discord?.active !== "" ? customerNotification.discord?.active ?? false : false;
      const slack_active =
        customerNotification.slack?.active !== "" ? customerNotification.slack?.active ?? false : false;
      const ntfy_active = customerNotification.ntfy?.active !== "" ? customerNotification.ntfy?.active ?? false : false;

      const chartwork_active =
        customerNotification.chatwork?.active !== "" ? customerNotification.chatwork?.active ?? false : false;

      const teamPlus_active =
        customerNotification.team_plus?.active !== "" ? customerNotification.team_plus?.active ?? false : false;
      setTelegramActive(telegram_active);
      setDiscordActive(discord_active);
      setSlackActive(slack_active);
      setNtfyActive(ntfy_active);
      setMailActive(mail_active);
      setTeamPlusActive(teamPlus_active);
      // setLineActive(line_active);
      setMQTTActive(customerNotification.mqtt?.active || "disable");
      setMQTTSecure(customerNotification.mqtt?.secure || "none");
      setChatworkActive(customerNotification.chatwork?.active || false);
      form.setFieldsValue({
        timezone: customerNotification.timezone,
        mail_active: mail_active,
        // mail_from: customerNotification.mail.mail_from,
        mail_to: customerNotification.mail.mail_to,
        // mail_token: customerNotification.mail.token,
        // mail_server: customerNotification.mail.mail_server,
        // mail_port: customerNotification.mail.mail_port,
        // line_token: customerNotification.line.token,
        // line_active: line_active,
        level: customerNotification.conditions.level || "INFO",
        // mqtt_active: customerNotification.mqtt?.active || "disable",
        // mqtt_ip: customerNotification.mqtt?.ip,
        // mqtt_port: customerNotification.mqtt?.port,
        // mqtt_topic: customerNotification.mqtt?.topic,
        // mqtt_secure: customerNotification.mqtt?.secure || "none",
        // mqtt_user: customerNotification.mqtt?.user,
        // mqtt_pwd: customerNotification.mqtt?.pwd,
        telegram_active: telegram_active,
        telegram_token: customerNotification?.telegram?.token ?? "",
        telegram_chat_id: customerNotification?.telegram?.chat_id ?? "",
        discord_active: discord_active,
        discord_url: customerNotification?.discord?.url ?? "",
        slack_active: slack_active,
        slack_token: customerNotification?.slack?.token ?? "",
        slack_channel_id: customerNotification?.slack?.channel_id ?? "",
        ntfy_active: ntfy_active,
        ntfy_topic: customerNotification?.ntfy?.topic ?? "",
        // TODO: O'smart RAM 2.3版本加入 team_plus 通知功能 25/04/08
        teamPlus_active: teamPlus_active,
        teamPlus_token: customerNotification?.team_plus?.token ?? "",
        teamPlus_url: customerNotification?.team_plus?.url ?? "",
        teamPlus_appName: customerNotification?.team_plus?.app_name ?? "",
        chatwork_active: chartwork_active || false,
        chatwork_token: customerNotification.chatwork?.token,
        chatwork_room_id: customerNotification.chatwork?.room_id,
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerNotification, NotifiModalvisible]);

    const TestNotifionFinish = () => {
      const valuesGeneral = form.getFieldsValue();
      testNotificationMutation({ values: valuesGeneral })
        .then(() => {
          message.success(t("ISMS.SendTest"));
        })
        .catch(() => {
          message.error(t("ISMS.Fail"));
        });
    };

    const generalTabFieldNames = ["level", "mail_active", "mail_to"]; // 根據你的欄位名稱
    // 如果需要針對 Channel Integration 的欄位，也可以另外定義或直接排除
    const channelTabFieldNames = [
      "telegram_active",
      "telegram_token",
      "telegram_chat_id",
      "slack_active",
      "slack_token",
      "slack_channel_id",
      "discord_active",
      "discord_url",
      "ntfy_active",
      "ntfy_topic",
      "chatwork_active",
      "chatwork_token",
      "chatwork_room_id",
      "teamPlus_active",
      "teamPlus_token",
      "teamPlus_url",
      "teamPlus_appName",
    ]; // 根據你的欄位名稱

    const onFinishFailed = (errorInfo: any) => {
      // 取得所有錯誤的欄位名稱
      const errorFields = errorInfo.errorFields.map((item: any) => item.name[0]);
      // 檢查是否有 General Settings 頁面的錯誤欄位
      const hasGeneralError = errorFields.some((name: any) => generalTabFieldNames.includes(name));
      const hasChannelError = errorFields.some((name: any) => channelTabFieldNames.includes(name));

      if (hasGeneralError && activeTab !== "1") {
        // 如果現在的 activeTab 沒有錯，才跳轉
        if (!hasChannelError) {
          setActiveTab("1");
        }
      } else if (hasChannelError && activeTab !== "2") {
        if (!hasGeneralError) {
          setActiveTab("2");
        }
      }
    };

    // const EditNotifionFinish = () => {
    //   const valuesGeneral = form.getFieldsValue();
    //   const valuesChannels = form.getFieldsValue();

    //   const combinedValues = {
    //     ...valuesGeneral,
    //     ...valuesChannels,
    //   };
    //   console.log("combinedValues", combinedValues);
    //   updateNotificationMutation({ values: combinedValues, cid: record.cid })
    //     .then(() => {
    //       message.success(t("ISMS.Success"));
    //     })
    //     .catch(() => {
    //       message.error(t("ISMS.Fail"));
    //     });
    // };
    const EditNotifionFinish = () => {
      const values = form.getFieldsValue();
      updateNotificationMutation({ values, cid: record.cid })
        .then(() => {
          message.success(t("ISMS.Success"));
        })
        .catch(() => {
          message.error(t("ISMS.Fail"));
        });
    };

    return (
      <Modal
        visible={NotifiModalvisible}
        title={t("ISMS.Notification")}
        onCancel={() => {
          setNotifiModalvisible(false);
          setRecord({ cid: undefined });
          form.resetFields();
          form.resetFields();
        }}
        centered={true}
        destroyOnClose={true}
        footer={[
          <Button
            key="test"
            loading={notiFetching}
            onClick={async () => {
              try {
                await form.validateFields();
                TestNotifionFinish();
              } catch (errorInfo) {
                // 觸發 tab 切換錯誤處理
                onFinishFailed(errorInfo);
              }
            }}
          >
            {t("ISMS.SendTest")}
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={notiFetching}
            onClick={() => {
              form.submit();
            }}
          >
            {t("ISMS.Submit")}
          </Button>,
        ]}
      >
        {notiFetching ? (
          <Spin tip="Loading...">
            <Alert
              message="Getting Data"
              description="We are now getting data from server, please wait for a few seconds"
            />
          </Spin>
        ) : (
          <Fragment>
            <Form onFinish={EditNotifionFinish} form={form} layout="vertical" onFinishFailed={onFinishFailed}>
              <Tabs
                defaultActiveKey="1"
                destroyInactiveTabPane={false}
                onChange={(key) => setActiveTab(key)}
                activeKey={activeTab}
              >
                <TabPane
                  // tab="Create User"
                  tab={t("ISMS.General Settings")}
                  key="1"
                  forceRender={true}
                >
                  <div className="formwrap">
                    <Row gutter={24} justify="space-around">
                      <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                        <h2>Level</h2>
                        <Divider className={styles.divider} />

                        <Form.Item name="level" label={t("ISMS.LeveltoInform")} initialValue={"INFO"}>
                          <Select>
                            <Option value="INFO">All </Option>
                            <Option value="WARN">Critical & Warning</Option>
                            <Option value="ERROR">Critical</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                        <h2>Mail</h2>
                        <Divider className={styles.divider} />

                        <Form.Item name="mail_active" label={t("ISMS.Mailactive")}>
                          <Select
                            onChange={(value: any) => {
                              setMailActive(value);
                              form.validateFields(["mail_to"]);
                              form.setFieldsValue({
                                mail_to: customerNotification.mail.mail_to,
                              });
                            }}
                            placeholder="Enable/ Disable"
                          >
                            {/* @ts-ignore */}
                            <Option value={true}>{t("ISMS.Enable")}</Option>
                            {/* @ts-ignore */}
                            <Option value={false}>{t("ISMS.Disable")}</Option>
                          </Select>
                        </Form.Item>
                        {MailActive && (
                          <Fragment>
                            {/* <Form.Item
                        label={t("ISMS.MailServer")}
                        name="mail_server"
                        rules={[{ required: MailActive, message: "required!" }, CharacterVerify]}
                      >
                        <Input placeholder={t("ISMS.InputServer")} maxLength={50} />
                      </Form.Item>
                      <Form.Item
                        label={t("ISMS.MailPort")}
                        name="mail_port"
                        rules={[{ required: MailActive, message: "required!" }]}
                      >
                        <InputNumber
                          max={999999999999999999}
                          min={0}
                          style={{ width: "100%" }}
                          placeholder={t("ISMS.InputPort")}
                        />
                      </Form.Item> */}
                            {/* <Form.Item
                        label={t("ISMS.MailFrom")}
                        name="mail_from"
                        rules={[
                          { required: MailActive, message: "required!" },
                          { type: "email", message: "Invalid!!" },
                        ]}
                      >
                        <Input placeholder={t("ISMS.MailAddress")} autoComplete="new-password" maxLength={50} />
                      </Form.Item> */}
                            {/* <Form.Item
                        label={t("ISMS.MailToken")}
                        name="mail_token"
                        rules={[{ required: MailActive, message: "required!" }, CharacterVerify]}
                      >
                        <Input.Password
                          placeholder={t("ISMS.Input Token")}
                          autoComplete="new-password"
                          maxLength={50}
                        />
                      </Form.Item> */}
                            <Form.Item
                              label={t("ISMS.MailTo")}
                              name="mail_to"
                              rules={[{ required: MailActive, message: "required!" }]}
                              validateStatus={!useSettingData?.mail_server_active ? "error" : undefined}
                              // validateStatus={"error"}
                              help={
                                !useSettingData?.mail_server_active
                                  ? "Please enable mail server and fill in mail server details in My Setting!"
                                  : ""
                              }
                              // help={"Please enable mail server and fill in mail server details in My Setting!"}
                            >
                              <Select
                                style={{ width: "100%" }}
                                placeholder={t("ISMS.MailAddress(multiple)")}
                                maxTagCount={2}
                                mode="tags"
                              />
                            </Form.Item>
                          </Fragment>
                        )}
                      </Col>

                      {/* <Col xs={24} sm={24} md={24} lg={10} xl={10}></Col> */}
                    </Row>
                  </div>
                </TabPane>
                <TabPane
                  // tab="Edit User"
                  tab={t("ISMS.Channel Settings")}
                  key="2"
                  forceRender={true}
                >
                  <div className="formwrap">
                    <Row gutter={24} justify="space-around">
                      {/* <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                  <h2>Line</h2>
                  <Divider className={styles.divider} />
                  <Form.Item name="line_active" label={t("ISMS.Lineactive")}>
                    <Select
                      onChange={(value: any) => {
                        setLineActive(value);
                        form.validateFields(["line_token"]);
                      }}
                      placeholder={"ON/OFF"}
                    >
                      <Option value={true}>{t("ISMS.Enable")}</Option>
                      <Option value={false}>{t("ISMS.Disable")}</Option>
                    </Select>
                  </Form.Item>
                  {LineActive && (
                    <Form.Item
                      label={t("ISMS.LineToken")}
                      name="line_token"
                      rules={[{ required: LineActive, message: "required!" }, CharacterVerify]}
                    >
                      <Input.Password autoComplete="new-password" placeholder={t("ISMS.Input Token")} maxLength={50} />
                    </Form.Item>
                  )}
                </Col> */}
                      <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                        <h2>Telegram</h2>
                        <Divider className={styles.divider} />
                        <Form.Item name="telegram_active" label={t("ISMS.Telegramactive")}>
                          <Select
                            onChange={(value: any) => {
                              setTelegramActive(value);
                              form.validateFields(["telegram_token", "telegram_chat_id"]);
                            }}
                            placeholder={"ON/OFF"}
                          >
                            <Option value={true}>{t("ISMS.Enable")}</Option>
                            <Option value={false}>{t("ISMS.Disable")}</Option>
                          </Select>
                        </Form.Item>
                        {telegramActive && (
                          <Form.Item
                            label={t("ISMS.Token")}
                            name="telegram_token"
                            rules={[{ required: telegramActive, message: "required!" }, CharacterVerifyTelegramToken]}
                          >
                            <Input.Password
                              autoComplete="new-password"
                              placeholder={t("ISMS.Input Token")}
                              maxLength={50}
                            />
                          </Form.Item>
                        )}
                        {telegramActive && (
                          <Form.Item
                            label={t("ISMS.ChatID")}
                            name="telegram_chat_id"
                            rules={[{ required: telegramActive, message: "required!" }, CharacterVerify]}
                          >
                            <Input placeholder={t("ISMS.Input Chat ID")} maxLength={30} />
                          </Form.Item>
                        )}
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                        <h2>Slack</h2>
                        <Divider className={styles.divider} />
                        <Form.Item name="slack_active" label={t("ISMS.Slackactive")}>
                          <Select
                            onChange={(value: any) => {
                              setSlackActive(value);
                              form.validateFields(["slack_token", "slack_channel_id"]);
                            }}
                            placeholder={"ON/OFF"}
                          >
                            <Option value={true}>{t("ISMS.Enable")}</Option>
                            <Option value={false}>{t("ISMS.Disable")}</Option>
                          </Select>
                        </Form.Item>
                        {slackActive && (
                          <Form.Item
                            label={t("ISMS.Token")}
                            name="slack_token"
                            rules={[{ required: slackActive, message: "required!" }, CharacterVerify]}
                          >
                            <Input.Password
                              autoComplete="new-password"
                              placeholder={t("ISMS.Input Token")}
                              maxLength={100}
                            />
                          </Form.Item>
                        )}
                        {slackActive && (
                          <Form.Item
                            label={t("ISMS.ChannelID")}
                            name="slack_channel_id"
                            rules={[{ required: slackActive, message: "required!" }, CharacterVerify]}
                          >
                            <Input placeholder={t("ISMS.Input Channel ID")} maxLength={50} />
                          </Form.Item>
                        )}
                      </Col>
                    </Row>
                    <Row gutter={24} justify="space-around">
                      <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                        <h2>Discord</h2>
                        <Divider className={styles.divider} />
                        <Form.Item name="discord_active" label={t("ISMS.Discordactive")}>
                          <Select
                            onChange={(value: any) => {
                              setDiscordActive(value);
                              form.validateFields(["discord_url"]);
                            }}
                            placeholder={"ON/OFF"}
                          >
                            <Option value={true}>{t("ISMS.Enable")}</Option>
                            <Option value={false}>{t("ISMS.Disable")}</Option>
                          </Select>
                        </Form.Item>
                        {discordActive && (
                          <Form.Item
                            label={"URL"}
                            name="discord_url"
                            rules={[{ required: discordActive, message: "required!" }, CharacterVerify]}
                          >
                            <Input placeholder={t("ISMS.Input Url")} maxLength={150} />
                          </Form.Item>
                        )}
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                        <h2>Ntfy</h2>
                        <Divider className={styles.divider} />
                        <Form.Item name="ntfy_active" label={t("ISMS.Ntfyactive")}>
                          <Select
                            onChange={(value: any) => {
                              setNtfyActive(value);
                              form.validateFields(["ntfy_topic"]);
                            }}
                            placeholder={"ON/OFF"}
                          >
                            <Option value={true}>{t("ISMS.Enable")}</Option>
                            <Option value={false}>{t("ISMS.Disable")}</Option>
                          </Select>
                        </Form.Item>
                        {ntfyActive && (
                          <Form.Item
                            label={t("ISMS.Topic")}
                            name="ntfy_topic"
                            rules={[{ required: ntfyActive, message: "required!" }, CharacterVerify]}
                          >
                            <Input placeholder={t("ISMS.Input Topic")} maxLength={50} />
                          </Form.Item>
                        )}
                      </Col>
                    </Row>

                    <Row gutter={24} justify="space-around">
                      {chatWorkNotify && (
                        <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                          <h2>Chatwork</h2>
                          <Divider className={styles.divider} />
                          <Form.Item name="chatwork_active" label={t("ISMS.Chatwork Active")}>
                            <Select
                              onChange={(value: any) => {
                                setChatworkActive(value);
                                form.validateFields(["chatwork_token", "chatwork_room_id"]);
                              }}
                              placeholder="ON/OFF"
                            >
                              {/* @ts-ignore */}
                              <Option value={true}>{t("ISMS.Enable")}</Option>
                              {/* @ts-ignore */}
                              <Option value={false}>{t("ISMS.Disable")}</Option>
                            </Select>
                          </Form.Item>

                          {ChatworkActive && (
                            <Fragment>
                              <Form.Item
                                label={t("ISMS.Token")}
                                name="chatwork_token"
                                rules={[{ required: ChatworkActive, message: "required!" }, CharacterVerify]}
                              >
                                <Input.Password
                                  autoComplete="new-password"
                                  placeholder={t("ISMS.Input Token")}
                                  maxLength={50}
                                />
                              </Form.Item>

                              <Form.Item
                                label={t("ISMS.Room ID")}
                                name="chatwork_room_id"
                                rules={[{ required: ChatworkActive, message: "required!" }, CharacterVerify]}
                              >
                                <Input placeholder={t("ISMS.Input Room_ID")} maxLength={50} style={{ width: "100%" }} />
                              </Form.Item>
                            </Fragment>
                          )}
                        </Col>
                      )}
                      {!teamPlusNotify && <Col xs={24} sm={24} md={24} lg={10} xl={10}></Col>}
                      {teamPlusNotify && (
                        <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                          <h2>TeamPlus</h2>
                          <Divider className={styles.divider} />

                          <Form.Item name="teamPlus_active" label={t("ISMS.TeamPlusactive")}>
                            <Select
                              onChange={(value: any) => {
                                setTeamPlusActive(value);
                                form.validateFields(["teamPlus_token", "teamPlus_url", "teamPlus_appName"]);
                              }}
                              placeholder="ON/OFF"
                            >
                              {/* @ts-ignore */}
                              <Option value={true}>{t("ISMS.Enable")}</Option>
                              {/* @ts-ignore */}
                              <Option value={false}>{t("ISMS.Disable")}</Option>
                            </Select>
                          </Form.Item>

                          {teamPlusActive && (
                            <Fragment>
                              <Form.Item
                                label={t("ISMS.Token")}
                                name="teamPlus_token"
                                rules={[{ required: teamPlusActive, message: "required!" }, CharacterVerify]}
                              >
                                <Input.Password
                                  autoComplete="new-password"
                                  placeholder={t("ISMS.Input Token")}
                                  maxLength={100}
                                />
                              </Form.Item>

                              <Form.Item
                                label={"URL"}
                                name="teamPlus_url"
                                rules={[{ required: teamPlusActive, message: "required!" }, CharacterVerify]}
                              >
                                <Input placeholder={t("ISMS.Input Url")} maxLength={100} style={{ width: "100%" }} />
                              </Form.Item>
                              <Form.Item
                                label={"App Name"}
                                name="teamPlus_appName"
                                rules={[{ required: teamPlusActive, message: "required!" }, CharacterVerify]}
                              >
                                <Input
                                  placeholder={t("ISMS.Input App Name")}
                                  maxLength={100}
                                  style={{ width: "100%" }}
                                />
                              </Form.Item>
                            </Fragment>
                          )}
                        </Col>
                      )}
                      {!chatWorkNotify && <Col xs={24} sm={24} md={24} lg={10} xl={10}></Col>}
                    </Row>
                  </div>
                </TabPane>
              </Tabs>
            </Form>
          </Fragment>
        )}
      </Modal>
    );
  }
);

export default NotifiModalC;
